// Identificador persistente do visitante/dispositivo (localStorage).
// O saldo de créditos é individual por device_id e registrado no backend/MongoDB.
// Sobrevive a refresh, troca de página, nova conversa e fechar/reabrir o navegador.
const KEY = "pronto_device_id";

export function getDeviceId() {
  if (typeof window === "undefined") return null;
  let id = null;
  try {
    id = window.localStorage.getItem(KEY);
    if (!id) {
      id = (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
        `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      window.localStorage.setItem(KEY, id);
    }
  } catch (e) {
    id = `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
  return id;
}

export function newRequestId() {
  return (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
    `req-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
